<template>
  <van-collapse v-model="activeNames">
    <van-collapse-item class="r-1" title="执行信息" name="1">
      <!-- <van-cell-group><van-field label="被执行人KeyNo" :value="data.executeKeyNo" placeholder="无" readonly /></van-cell-group> -->
      <van-cell-group><van-field label="被执行人名称" :value="data.executeName" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="股权数额" :value="data.equityAmount" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="执行法院" :value="data.executeCourt" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="执行通知文书号" :value="data.executionNoticeNum" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
    <van-collapse-item title="冻结股权标的企业信息" name="2">
      <!-- <van-cell-group><van-field label="KeyNo" :value="data.relatedInfo.keyNo" placeholder="无" readonly /></van-cell-group> -->
      <van-cell-group><van-field label="名称" :value="data.relatedInfo.name" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
    <van-collapse-item title="股权冻结情况" name="3">
      <van-cell-group><van-field label="执行文书文号" :value="data.equityFreezeDetail.executionDocNum" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="执行事项" :value="data.equityFreezeDetail.executionMatters" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="执行裁定书文号" :value="data.equityFreezeDetail.executionVerdictNum" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="被执行人证件种类" :value="data.equityFreezeDetail.executedPersonDocType" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="被执行人证件号码" :value="data.equityFreezeDetail.executedPersonDocNum" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="冻结开始日期" :value="data.equityFreezeDetail.freezeStartDate" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="冻结结束日期" :value="data.equityFreezeDetail.freezeEndDate" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="冻结期限" :value="data.equityFreezeDetail.freezeTerm" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="公示日期" :value="data.equityFreezeDetail.publicDate" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
    <van-collapse-item title="解除解冻情况" name="4">
      <van-cell-group><van-field label="执行裁定书文号" :value="data.equityUnFreezeDetail.executionVerdictNum" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="执行事项" :value="data.equityUnFreezeDetail.executionMatters" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="执行文书文号" :value="data.equityUnFreezeDetail.executionDocNum" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="被执行人证件种类" :value="data.equityUnFreezeDetail.executedPersonDocType" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="被执行人证件号码" :value="data.equityUnFreezeDetail.executedPersonDocNum" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="解除冻结日期" :value="data.equityUnFreezeDetail.unFreezeDate" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="公示日期" :value="data.equityUnFreezeDetail.publicDate" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="解冻机关" :value="data.equityUnFreezeDetail.thawOrgan" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="解冻文书号" :value="data.equityUnFreezeDetail.thawDocNo" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
  </van-collapse>
</template>

<script>
import detailMixin from "../mixins/detail-mixin"
export default {
  name: "equityFreezeCheckDetail",
  mixins: [detailMixin],
  data() {
    return {
      activeNames: ["1", "2", "3", "4"]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "../style.scss";
.r-1 /deep/ .van-collapse-item__content {
  padding: 0px 16px;
}
.coll2 .van-cell__value {
  flex: 1;
  margin-left: 8px;
}
.coll2 .van-cell {
  padding: 10px 0;

  &::after{
    left: 0;
  }
}

.coll3 /deep/ .van-field__label {
  flex: 1;
}
</style>